// Vendor
import * as React from 'react';

const Methodology: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1>Methodology</h1>
      <p className="tup-body leading-7">
        thredUP’s Annual Resale Report contains research and data from
        GlobalData, a third-party retail analytics firm. GlobalData’s assessment
        of the secondhand market is determined through consumer surveys,
        retailer tracking, official public data, data sharing, store
        observation, and secondary sources. These inputs are used by analysts to
        model and calculate market sizes, channel sizes, and market shares.
        Further, for the purpose of this report, GlobalData conducted a January
        2020 survey of 3,500 American women over 18, asking specific questions
        about their behaviors and preferences for secondhand. thredUP’s Resale
        Report also leverages data from the following sources: Green Story Inc.
        research and internal thredUP customer and brand performance data. View
        all sources{' '}
        <a className="underline" href="#sources">
          here
        </a>
        .
      </p>

      <p className="tup-body leading-7">
        <b>Covid Update:</b> All market numbers were reforecasted in April 2020
        to more accurately reflect the current situation, and are included
        throughout the report. GlobalData ran a post-Covid consumer survey in
        April 2020 to better understand how recent events have shifted consumer
        sentiment and behaviors. Those findings are included in the Covid
        section at the beginning of thredUP&rsquo;s Annual Resale Report.
      </p>

      <p className="tup-body leading-7">
        <b>Disclosure:</b> All third-party brand names and logos appearing in
        this report are trademarks or registered trademarks of their respective
        holders. Any such appearance does not imply any affiliation with or
        endorsement of thredUP.
      </p>

      <p className="tup-body leading-7">Published: June 2020</p>
    </div>
  );
};

export { Methodology };
